<template>
  <div id="app">

    <LanguageSwitcher/>
    <router-view/>
    <div class="copyright">© <a href="https://linkedin.com/in/galyna-golovko-8307ab2a">{{$t('galyna-golovko')}}</a> & <a
            href="https://www.iena.info">{{$t('oleksandr-iena')}}</a></div>
  </div>
</template>

<script>
  import LanguageSwitcher from './components/LanguageSwitcher';
  export default {
    name: 'App',
    components: {
      LanguageSwitcher

    },
  };
</script>
<style>
  #app {
    background-color: dimgray;
    height: 100vh;
  }

  .copyright {

    position: relative;
    text-align: center;
    bottom: 100px;
  }

  a {
    text-decoration: none;
  }

  a:link, a:visited {
    color: black;
  }
</style>
